import {
  File as FileIcon,
  FileArchive,
  FileAudio,
  FileCode,
  FileImage,
  FileSpreadsheet,
  FileText,
  FileVideo,
  Presentation,
  Type as TypeIcon,
} from "lucide-react";

import type { FileTypeKey } from "@/constants/fileUpload";

const FILE_TYPE_ICONS: Record<FileTypeKey, typeof FileIcon> = {
  image: FileImage,
  video: FileVideo,
  audio: FileAudio,
  document: FileText,
  spreadsheet: FileSpreadsheet,
  presentation: Presentation,
  archive: FileArchive,
  font: TypeIcon,
  code: FileCode,
  other: FileIcon,
};

interface FileTypeIconProps {
  fileType: FileTypeKey;
  className?: string;
}

/** Lucide glyph for a File Bucket item, keyed by its resolved file type. */
export const FileTypeIcon: React.FC<FileTypeIconProps> = ({
  fileType,
  className = "w-5 h-5",
}) => {
  const Icon = FILE_TYPE_ICONS[fileType] ?? FileIcon;
  return <Icon className={className} />;
};

export default FileTypeIcon;
